'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var cartComponent = exports.cartComponent = {
    template: require('./cart.html'),
    bindings: {
        cart: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$state", "$stateParams", "$timeout", "cartService", "common", "exceptionService", "gettextCatalog", "dialogService", "Analytics", "authService", "$window", function checkoutCartController($scope, $state, $stateParams, $timeout, cartService, common, exceptionService, gettextCatalog, dialogService, Analytics, authService, $window) {
        'ngInject';

        var vm = this;
        vm.isLoading = false;
        vm.messages = null;
        vm.removeProducts = removeProducts;
        vm.updateQuantity = updateQuantity;
        vm.quantityChanged = quantityChanged;
        vm.undoChanged = undoChanged;
        vm.removeInactiveProducts = removeInactiveProducts;
        vm.checkout = checkout;
        vm.clear = clear;
        vm.$onInit = init;
        vm.cartUpdated = false;
        vm.productDiscounts = {};
        vm.removeSellerFromCart = removeSellerFromCart;

        function init() {
            var tenants = authService.customUserInfo.tenants;
            var activeTenant = tenants && tenants.find(function (t) {
                return !!t.secondaryAppUserKey && t.secondaryAppUserKey === authService.user.SAUK || !!t.id && t.id === parseInt(authService.user.BuyerID, 10);
            });
            vm.apbNumber = activeTenant.apbNumber;

            common.navigationMenu.clearActiveMenu();
            common.setTitle(gettextCatalog.getString('Shopping cart'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/cart', gettextCatalog.getString('Shopping cart'));

            vm.isLoading = true;
            cartService.getFromServer().then(function (cart) {
                vm.cart = cart;
                vm.isLoading = false;
                if (vm.cart) {
                    vm.initCart = angular.copy(vm.cart);
                    vm.cart.setFocusOnProduct($stateParams.productId);
                }

                //update quantity on enter
                angular.element($window).on('keydown', function (event) {
                    if (event.which === 13 && vm.addingProducts !== true) {
                        vm.updateQuantity();
                    }
                });
            });
        }

        $scope.$on('$destroy', function () {
            angular.element($window).off('keydown');
        });

        function quantityChanged() {
            vm.cartUpdated = true;
        }

        function removeSellerFromCart(sellerBaseCodeId) {
            vm.isLoading = true;
            vm.cartUpdated = false;

            cartService.removeSellerFromCart(sellerBaseCodeId).then(function (updatedCart) {
                vm.cart = updatedCart;
                vm.initCart = angular.copy(updatedCart);
                vm.isLoading = false;
            }).catch(function () {
                var msg = gettextCatalog.getString('The products could not be removed from your shopping cart');
                exceptionService.logException(msg);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function removeProducts(products) {
            vm.isLoading = true;
            vm.cartUpdated = false;

            cartService.removeProducts(products).then(function (updatedCart) {
                vm.cart = updatedCart;
                vm.initCart = angular.copy(updatedCart);
                vm.isLoading = false;
            }).catch(function () {
                var msg = gettextCatalog.getString('The product could not be removed from your shopping cart');
                exceptionService.logException(msg);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function updateQuantity() {

            vm.isLoading = true;
            vm.cartUpdated = false;

            var products = [];

            vm.cart.sellers.map(function (seller) {
                products = products.concat(seller.products);
            });

            cartService.updateCart(products).then(function (updatedCart) {
                vm.cart = updatedCart;
                vm.initCart = angular.copy(updatedCart);
            }).catch(function () {
                var msg = gettextCatalog.getString('The product quantity could not be updated');
                exceptionService.logException(msg);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function checkout(number) {
            vm.cart.customerAccountNumber = number;
            angular.forEach(vm.cart.sellers, function (seller) {
                angular.forEach(seller.products, function (product) {
                    Analytics.addProduct(product.id, product.displayName, product.type, product.brand, '', product.totalPriceWithDiscount, product.quantity, '', '', {
                        dimension1: product.sellerId,
                        dimension2: product.sellerName,
                        dimension3: product.discountId
                    });
                });
            });
            Analytics.trackCheckout(1);

            $state.go('checkout-order');
        }

        function clear() {
            var title = gettextCatalog.getString('Confirmation');
            var msg = gettextCatalog.getString('Are you sure you want to clear your shopping cart?');

            dialogService.confirm($scope, title, msg).then(function () {
                return cartService.clear();
            }).then(function () {
                vm.cart = null;
            });
        }

        function undoChanged() {
            vm.cartUpdated = false;
            vm.cart = angular.copy(vm.initCart);
        }

        function removeInactiveProducts() {
            vm.isLoading = true;
            vm.cartUpdated = false;

            var products = [];
            vm.cart.sellers.map(function (seller) {
                products = products.concat(seller.products);
            });

            var inactiveProducts = products.filter(function (product) {
                return product.isExpired === true;
            });

            cartService.removeProducts(inactiveProducts).then(function (updatedCart) {
                vm.cart = updatedCart;
                vm.initCart = angular.copy(updatedCart);
                vm.isLoading = false;
            }).catch(function () {
                var msg = gettextCatalog.getString('The product could not be removed from your shopping cart');
                exceptionService.logException(msg);
            }).finally(function () {
                vm.isLoading = false;
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/checkout/cart.js
// module id = 904
// module chunks = 0